// Enums
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
import { KycStatesEnumeration } from '../enumerations/kyc-states.enumeration';
// Resolvers
import { backPreviousStateResolver } from 'resolvers/back-state.resolver';
// Types
import { KycBuilderHandlersType, KycReturnHandlersType } from './types/kyc.handlers.type';

const updateKycHeaderBackClickHandler = async ({
  setError,
  setKycState,
}: KycBuilderHandlersType): Promise<void> => {
  const [success] = await backPreviousStateResolver();

  if (success) {
    setKycState(KycStatesEnumeration.LANDING);
  } else {
    setError(AppErrorEnumeration.BACK_STATE_KYC_FAILED);
  }
};

const KycHandlers = (props: KycBuilderHandlersType): KycReturnHandlersType => ({
  handleUpdateKycHeaderBackClick: () => updateKycHeaderBackClickHandler(props),
});

export { KycHandlers };
